import {client} from './services/client'

export  const formepharmacetiques = {
    namespaced:true,
    state:{
        formepharmacetiques:[],
        formepharmacetiqueloading:true,
    },
    mutations: {
        SET_FORMEPHARMACETIQUE (state,formepharmacetiques){
            state.formepharmacetiques = formepharmacetiques
        },

        SET_FORMEPHARMACETIQUELOADING (state,formepharmacetiques){
            state.formepharmacetiqueloading = formepharmacetiques
        },


    },
    actions: {
        getFormepharmacetique({commit}){
            commit('SET_FORMEPHARMACETIQUELOADING',true)
            return new Promise((resolve,reject)=>{
                client({
                    method : 'get',
                    url:'/formepharmacetique/get',
                })
                    .then((response)=>{
                        let formepharmacetiques = response.data.formepharmacetiques;
                        console.log(formepharmacetiques);
                        commit('SET_FORMEPHARMACETIQUE',formepharmacetiques)
                        commit('SET_FORMEPHARMACETIQUELOADING',false)
                    })
                    .catch((error)=>{
                        reject(error);
                    })
            })

        },

        setFormepharmacetique({commit},data){
            commit('SET_FORMEPHARMACETIQUELOADING',true)
            return new Promise((resolve,reject)=>{
                client({
                    method : 'post',
                    url:'/formepharmacetique/save',
                    data:data,
                })
                    .then((response)=>{
                        let formepharmacetiques = response.data.formepharmacetiques;
                        commit('SET_FORMEPHARMACETIQUE',formepharmacetiques);
                        commit('SET_FORMEPHARMACETIQUELOADING',false)
                        resolve(response);
                    })
                    .catch((error)=>{
                        reject(error);
                    })
            });
        },
        deleteFormepharmacetique({commit},id){
            commit('SET_FORMEPHARMACETIQUELOADING',true)
            return new Promise((resolve,reject)=>{
                client({
                    method : 'get',
                    url:'/formepharmacetique/delete/'+id,
                })
                    .then((response)=>{
                        let formepharmacetiques = response.data.formepharmacetiques;
                        commit('SET_FORMEPHARMACETIQUE',formepharmacetiques);
                        commit('SET_FORMEPHARMACETIQUELOADING',false)
                    })
                    .catch((error)=>{
                        reject(error)
                    })
            })
        },
    },
    getters: {
        getFormepharmacetique: state  => {
            return state.formepharmacetiques
        },
    }
};
